import { render, staticRenderFns } from "./house-form.html?vue&type=template&id=806a00ba&scoped=true&external"
import script from "./house-form.js?vue&type=script&lang=js&external"
export * from "./house-form.js?vue&type=script&lang=js&external"
import style0 from "./house-form.scss?vue&type=style&index=0&id=806a00ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806a00ba",
  null
  
)

export default component.exports